import { render, staticRenderFns } from "./BusinessMenu.vue?vue&type=template&id=1a76ce44&"
import script from "./BusinessMenu.vue?vue&type=script&lang=js&"
export * from "./BusinessMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports